@include host-component-properties;

:host {
  --paf-result-day-change-title-margin-block: 36;
  --paf-result-day-change-title-font-size: 24;
}

.title {
  font-size: px-to-rem(var(--paf-result-day-change-title-font-size));
  font-weight: var(--paf-global-font-weight-bold);
  margin-inline: 0;
  margin-block: px-to-rem(var(--paf-result-day-change-title-margin-block));
  text-align: center;
}

.hidden {
  @include screen-reader-only;
}
